module.exports = __webpack_public_path__ + "static/media/history_31.49d8b182.jpg";